import * as React from "react";
import dayjs from "dayjs";
import { Box, Button, Stack, Typography, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";

const shortcutsItems = [
  {
    label: "This Week",
    getValue: () => {
      const today = dayjs();
      return [today.startOf("week"), today.endOf("week")];
    },
  },
  {
    label: "Last Week",
    getValue: () => {
      const today = dayjs();
      const prevWeek = today.subtract(7, "day");
      return [prevWeek.startOf("week"), prevWeek.endOf("week")];
    },
  },
  {
    label: "Last 7 Days",
    getValue: () => {
      const today = dayjs();
      return [today.subtract(7, "day"), today];
    },
  },
  {
    label: "Current Month",
    getValue: () => {
      const today = dayjs();
      return [today.startOf("month"), today.endOf("month")];
    },
  },
  {
    label: "Next Month",
    getValue: () => {
      const today = dayjs();
      const startOfNextMonth = today.endOf("month").add(1, "day");
      return [startOfNextMonth, startOfNextMonth.endOf("month")];
    },
  },
  { label: "Reset", getValue: () => [null, null] },
];

export default function BasicRangeShortcutsFree({
  setStartDate,
  setEndDate,
  startDate,
  endDate,
}) {
  const handleShortcutClick = (getValueFn) => {
    const [start, end] = getValueFn();

    const formattedStart = start ? dayjs(start).format("YYYY-MM-DD") : null;
    const formattedEnd = end ? dayjs(end).format("YYYY-MM-DD") : null;

    setStartDate(formattedStart);
    setEndDate(formattedEnd);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box p={2}>
        <Box sx={{ overflowX: "auto", whiteSpace: "nowrap", mb: 2 }}>
          <Stack direction="row" spacing={1} sx={{ width: "max-content" }}>
            {shortcutsItems.map((shortcut) => (
              <Button
                key={shortcut.label}
                size="small"
                variant="outlined"
                onClick={() => handleShortcutClick(shortcut.getValue)}
              >
                {shortcut.label}
              </Button>
            ))}
          </Stack>
        </Box>

        <Stack direction="row" spacing={2} sx={{ flexWrap: "wrap" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Start Date
              </Typography>
              <StaticDatePicker
                displayStaticWrapperAs="desktop"
                value={startDate ? dayjs(startDate) : null}
                onChange={(newValue) =>
                  setStartDate(dayjs(newValue).format("YYYY-MM-DD"))
                }
              />
            </Box>

            <Box>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                End Date
              </Typography>
              <StaticDatePicker
                displayStaticWrapperAs="desktop"
                value={endDate ? dayjs(endDate) : null}
                onChange={(newValue) =>
                  setEndDate(dayjs(newValue).format("YYYY-MM-DD"))
                }
              />
            </Box>
          </LocalizationProvider>
        </Stack>
      </Box>
    </LocalizationProvider>
  );
}
